import type { MarketDataDto } from "../../../shared/types/MarketDataDto";
import { BaseAssetDto } from "../../../shared/types/BaseAssetDto";

export function getBaseAssetById(
    marketDataDto: MarketDataDto | undefined,
    baseAssetSymbol: string | undefined | null
) : BaseAssetDto | null {
    return marketDataDto?.AvailableBaseAssets
        .find((x) => x.Symbol === baseAssetSymbol) ?? null;
}

export function isAnyBaseAssetAvailable(marketDataDto: MarketDataDto | undefined): boolean {
    return (marketDataDto?.AvailableBaseAssets.length ?? 0) != 0;
}